import React, { useState, useEffect } from "react";
import whatsapp from "../assets/whatsapp.webp";
import phoneIcon from "../assets/phone.webp";

const WhatsappButton = () => {
  const phoneNumber = "919014162312";
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth <= 1024);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex gap-3">
      {/* WhatsApp Button (always shown) */}
      <a
        href={`https://wa.me/${phoneNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      >
        <img src={whatsapp} alt="WhatsApp" className="w-10 h-10" />
      </a>

      {/* Phone Button (only for mobile/tablet) */}
      {isMobileOrTablet && (
        <a
          href={`tel:+${phoneNumber}`}
          className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
        >
          <img src={phoneIcon} alt="Phone" className="w-10 h-10" />
        </a>
      )}
    </div>
  );
};

export default WhatsappButton;
